import { set } from "date-fns";
import { useEffect } from "react"
import { useState, useContext } from "react";
import { format } from "date-fns";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { AuthContext } from "../AuthContext";
import { VictoryAxis, VictoryChart, VictoryLine, VictoryPie, VictoryTheme, VictoryTooltip } from "victory";
import { getProfilePicSrc } from "../utils/mediaUrl";
import { EnvelopeIcon } from "@heroicons/react/24/outline";


  





  export default function Logins() {

    const [people, setPeople] = useState([])
    const [range, setRange] = useState('week')
    const [mfaData, setMFAData] = useState([])

const user = useContext(AuthContext)


  const fetchAllStaff = async () => {

    try {
      const response = await fetch('https://api.insightos.co.uk/api/staff', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setMFAData(data.data); // Assuming the API returns an array of staff members in data.data
    } catch (error) {
      console.error('Error fetching staff data:', error);
    }

  }

  useEffect(() => {
    fetchAllStaff();
  }, []);




      const fetchData = async () => {

        try {
          const response = await fetch('https://api.insightos.co.uk/api/usersessions', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
credentials: 'include',
            });

            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

          const data = await response.json()
          console.log(data)


// process the data to 

const processedStaff = data.data.map((person) => ({
  ...person,
  ProfilePic: getProfilePicSrc(person),
}));

          setPeople(processedStaff)

        } catch (error) {
          console.error('Error fetching data:', error)
        }

      }

      useEffect(() => {

      fetchData()
        
        }
      , [])


const handleResetMFA = async (userId) => {
  try {
    const response = await fetch("https://api.insightos.co.uk/api/reset-mfa", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ userId }),
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    if (data.success) {
      fetchData(); // Refresh the data after resetting MFA
      fecthAllStaff(); // Refresh the MFA data after resetting MFA
      console.log("MFA reset successfully");
    } else {
      console.error("Error resetting MFA:", data.message);
    }
  } catch (error) {
    console.error("Error resetting MFA:", error);
  }
};

    const handleBootUser = async (userId) => {

      console.log(userId)


      try {
        const response = await fetch("https://api.insightos.co.uk/api/boot-user", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",

          body: JSON.stringify({ userId }),
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.success) {

          // wait for 

          fetchData(); // Refresh the data after booting a user
          console.log("User booted successfully");
        } else {
          console.error("Error booting user:", data.message);
        }
      } catch (error) { 
        console.error("Error booting user:", error);
      }
    };










      const buildRangeData = (rangeKey) => {
        const now = new Date();
        const end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        let start = new Date(end);
        if (rangeKey === 'today') {
          start = new Date(end);
        } else if (rangeKey === 'week') {
          start.setDate(start.getDate() - 6);
        } else if (rangeKey === 'month') {
          start.setDate(start.getDate() - 29);
        } else if (rangeKey === 'year') {
          start.setDate(start.getDate() - 364);
        }

        const dayCount = Math.ceil((end - start) / (24 * 60 * 60 * 1000)) + 1;
        const map = new Map();
        people.forEach((person) => {
          const created = new Date(person.created_at);
          if (created >= start && created <= new Date(end.getTime() + 24 * 60 * 60 * 1000 - 1)) {
            const key = format(created, 'yyyy-MM-dd');
            map.set(key, (map.get(key) || 0) + 1);
          }
        });

        return Array.from({ length: dayCount }).map((_, idx) => {
          const date = new Date(start);
          date.setDate(start.getDate() + idx);
          const key = format(date, 'yyyy-MM-dd');
          return {
            x: format(date, rangeKey === 'year' ? 'MMM' : 'dd/MM'),
            y: map.get(key) || 0,
          };
        });
      };

      const deviceTypeData = Object.values(
        people.reduce((acc, person) => {
          const key = (person.device_type || 'unknown').toLowerCase();
          acc[key] = acc[key] || { x: key, y: 0 };
          acc[key].y += 1;
          return acc;
        }, {})
      );

      const loginTrendData = buildRangeData(range);

      const rangeOptions = [
        { key: 'today', label: 'Today' },
        { key: 'week', label: 'Week' },
        { key: 'month', label: 'Month' },
        { key: 'year', label: 'Year' },
      ];

      // Rest of your existing code...

      return (
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="sm:flex sm:items-center">
            <div className="sm:flex-auto">
              <h1 className="text-base font-semibold text-gray-900">Users</h1>
              <p className="mt-2 text-sm text-gray-700">
                A list of all the users in your account including their name, title, email and role.
              </p>
            </div>
            <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
              {user.access === "admin" && (
            <button
        type="button"
        className="inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <XMarkIcon aria-hidden="true" className="-ml-0.5 size-5" />
        Boot All Users
      </button>
              )}
            </div>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-2">
            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="flex items-center justify-between">
                <h2 className="text-sm font-semibold text-gray-900">Device Types</h2>
              </div>
              {deviceTypeData.length > 0 ? (
                <VictoryPie
                  data={deviceTypeData}
                  colorScale={['#6366f1', '#06b6d4', '#22c55e', '#f59e0b', '#ef4444']}
                  labels={({ datum }) => `${datum.x}: ${datum.y}`}
                  labelComponent={<VictoryTooltip />}
                  theme={VictoryTheme.material}
                  style={{ labels: { fontSize: 12 } }}
                  height={240}
                />
              ) : (
                <p className="text-sm text-gray-500">No device data available.</p>
              )}
            </div>

            <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
              <div className="flex flex-wrap items-center justify-between gap-2">
                <h2 className="text-sm font-semibold text-gray-900">Login Trend</h2>
                <div className="flex flex-wrap gap-2">
                  {rangeOptions.map((option) => (
                    <button
                      key={option.key}
                      type="button"
                      onClick={() => setRange(option.key)}
                      className={`rounded-full px-3 py-1 text-xs font-semibold ${
                        range === option.key
                          ? 'bg-indigo-600 text-white'
                          : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                      }`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
              <VictoryChart
                theme={VictoryTheme.material}
                height={240}
                padding={{ top: 20, bottom: 50, left: 50, right: 20 }}
              >
                <VictoryAxis
                  style={{ tickLabels: { fontSize: 10, angle: -35, padding: 12 } }}
                />
                <VictoryAxis dependentAxis style={{ tickLabels: { fontSize: 10 } }} />
                <VictoryLine
                  data={loginTrendData}
                  interpolation="monotoneX"
                  style={{ data: { stroke: '#6366f1', strokeWidth: 3 } }}
                />
              </VictoryChart>
            </div>
          </div>

          <div className="mt-8 flow-root">
            <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0">
                        Name
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Role
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Status
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Times
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Device
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        Access
                      </th>
                      <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">
                        User Agent
                      </th>
                      <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-0">
                        <span className="sr-only">Edit</span>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {people.map((person) => (
                      <tr key={person.user_id}>
                        <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm sm:pl-0">
                          <div className="flex items-center">
                            <div className="size-11 shrink-0">
                              <img alt="" src={person.ProfilePic} className="size-11 rounded-full" />
                            </div>
                            <div className="ml-4">
                              <div className="font-medium text-gray-900">{person.Name}</div>
                              <div className="mt-1 text-gray-500">{person.Email}</div>
                            </div>
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div className="text-gray-900">{person.Role}</div>
                          <div className="mt-1 text-gray-500">{person.Department}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <span className="inline-flex items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                            Active
                          </span>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div className="text-gray-900">{format(new Date(person.created_at), "HH:mm dd/MM/yyyy")}</div>
                          <div className="mt-1 text-gray-500">{format(new Date(person.expires_at), "HH:mm dd/MM/yyyy")}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div className="text-gray-900 capitalize">{person.device_type || 'Unknown'}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">{person.Access}</td>
                        <td className="max-w-xs px-3 py-5 text-sm text-gray-500">
                          <span title={person.user_agent || ''} className="block truncate">
                            {person.user_agent || 'Unknown'}
                          </span>
                        </td>
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                         {person.booted === 0 && person.Access !== "admin" && (
                          <button onClick={() => handleBootUser(person.user_id)}
        type="button"
        className="inline-flex items-center gap-x-2 rounded-md bg-red-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        <XMarkIcon aria-hidden="true" className="-ml-0.5 size-5" />
        Boot User
      </button>                         
                          )}
                          {person.booted === 1 && person.Access !== "admin" && (
                            <span className="text-red-600">Booted</span>
                          )}

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

         <ul role="list" className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {mfaData.map((person) => (
        <li
          key={person.Email}
          className="col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow dark:divide-white/10 dark:bg-gray-800/50 dark:shadow-none dark:outline dark:outline-1 dark:-outline-offset-1 dark:outline-white/10"
        >
          <div className="flex w-full items-center justify-between space-x-6 p-6">
            <div className="flex-1 truncate">
              <div className="flex items-center space-x-3">
                <h3 className="truncate text-sm font-medium text-gray-900 dark:text-white">{person.Name}</h3>
                <span className="inline-flex shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 dark:bg-green-500/10 dark:text-green-500 dark:ring-green-500/10">
                  {person.Role}
                </span>
              </div>
              <p className="mt-1 truncate text-sm text-gray-500 dark:text-gray-400">{person.Department}</p>
            </div>
            <img
              alt=""
              src="1.png"
              className="size-10 shrink-0 rounded-full bg-gray-300 outline outline-1 -outline-offset-1 outline-black/5 dark:bg-gray-700 dark:outline-white/10"
            />
          </div>
          <div>
            <div className="-mt-px flex divide-x divide-gray-200 dark:divide-white/10">
            {person.mfa_setup_complete === 1 && (
                <div className="flex w-0 flex-1">
                  <span className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900 dark:text-white">
                    <span className="text-green-600 dark:text-green-500">MFA Enabled</span>
                  </span>
                </div>
              )}
              {person.mfa_setup_complete === 0 && (
                <div className="flex w-0 flex-1">
                  <span className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900 dark:text-white">
                    <span className="text-red-600 dark:text-red-500">MFA Not Enabled</span>
                  </span>
                </div>
              )}
              <div className="flex w-0 flex-1">
                <button
                  onClick={() => handleResetMFA(person.user_id)}
                  className="relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-gray-900 dark:text-white"
                >
                  <EnvelopeIcon aria-hidden="true" className="size-5 text-gray-400 dark:text-gray-500" />
                  Reset MFA
                </button>
              </div>
            </div>
          </div>
        </li>
      ))}
    </ul>

        </div>
      )
    }
  
  